import { Button, FormError, Input, Label } from "@simplicity/ui";
import { useState } from "react";
import { useNavigate } from "react-router";
import { apiFetch } from "../../api";
import type { Project } from "../../configTypes";
import { Breadcrumbs } from "./Breadcrumbs";

export function CreateProject() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      const project = await apiFetch<Project>("/api/projects", {
        method: "POST",
        body: JSON.stringify({ name: name.trim() }),
      });
      void navigate(`/config/projects/${project.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to create project");
      setSubmitting(false);
    }
  }

  return (
    <div className="mx-auto max-w-4xl">
      <Breadcrumbs
        items={[{ label: "Projects", to: "/config/projects" }, { label: "New Project" }]}
      />
      <h2 className="mb-6 text-2xl text-foreground">Create Project</h2>
      <div className="form-card max-w-[540px]">
        <form onSubmit={(e) => void handleSubmit(e)}>
          <div className="mb-4">
            <Label htmlFor="project-name" className="form-label">
              Name
            </Label>
            <Input
              id="project-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. ABC School"
              // eslint-disable-next-line jsx-a11y/no-autofocus -- single-purpose route page; focus initial field on mount
              autoFocus
              autoComplete="one-time-code"
            />
          </div>
          {error && <FormError assertive>{error}</FormError>}
          <div className="form-actions">
            <Button type="button" variant="outline" onClick={() => void navigate(-1)}>
              Cancel
            </Button>
            <Button type="submit" disabled={submitting || !name.trim()}>
              {submitting ? "Creating..." : "Create"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
